import { createApp } from 'vue'  // no vue-router
// import Vue from 'vue'
import App from './App.vue'
import {router} from './route'

// createApp(App).mount('#app') // no vue-router
// new Vue({
//     el: '#app',
//     components: {App},
//     template: '<App/>'
// })

const app = createApp(App)
app.use(router)
app.mount('#app')